import { jsx as _jsx } from "react/jsx-runtime";
import { Kbd as HeroKbd } from '@heroui/react';
export const Kbd = (props) => {
    return _jsx(HeroKbd, { ...props });
};
export default Kbd;
//# sourceMappingURL=Kbd.js.map